var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll", staticStyle: { height: "calc(100vh - 100px)" } },
    [
      _c("dialogue", {
        attrs: {
          title: "Add Box",
          paragraph: _vm.box_dialogue_text,
          button_names: ["Yes", "No"],
          show: _vm.box_dialogue
        },
        on: { dialogue: _vm.addBox, cancel: _vm.cancelBox }
      }),
      _vm._v(" "),
      _c("checkitem", {
        attrs: { show: _vm.checkOpen, isIn: _vm.checkIsIn, itemId: _vm.term },
        on: { cancel: _vm.closeCheck, dialogue: _vm.checkItem }
      }),
      _vm._v(" "),
      _c("layout-3", {
        key: _vm.updateKey,
        attrs: { id: _vm.pageid, term: _vm.term, width: 5, height: 3 }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c("layout-1", {
        attrs: {
          table_name: "Transactions",
          id: _vm.pageid3,
          searchbar: false,
          collapseable: true,
          height_limit: true,
          navbar: false,
          select_reroute: false,
          term: _vm.term
        }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "margin-left": "25px", "margin-right": "25px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "16px" } },
        [
          _c("inventorypics", {
            staticStyle: { width: "100%" },
            attrs: {
              inventorypic_id: _vm.term,
              imageCount: 99,
              height: "300px"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "div",
          [
            _vm._l(_vm.nav_items, function(item, index) {
              return _vm.perms.includes(_vm.nav_item_perms[index])
                ? _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.button(item)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item))]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.check(false)
                  }
                }
              },
              [_vm._v("Check Out")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    return _vm.check(true)
                  }
                }
              },
              [_vm._v("Check In")]
            )
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c95fbde8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c95fbde8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/View_Inventory.vue
// module id = 576
// module chunks = 0